import {createReducer} from '@reduxjs/toolkit'
import { logoutAC } from 'model/system/systemActionCreators'
import {settingsSetCallbackDataAC, settingsSetCallbackLoaderAC} from './settingsActionCreators'


// Types
export type typeCallbackDataItem = {
    id?: string,
    eventType: 'ORDER' | 'SALE' | 'REFUND' | 'Z_REPORT',
    url: string,
}

export type typeSettingsState = {
    callbackLoader: boolean,
    callbackData: typeCallbackDataItem[],
}

// Init state
export const initialState: typeSettingsState = {
    callbackLoader: false,
    callbackData: [],
}


// Reducer
export const SettingsReducer = createReducer(initialState, builder => {
    builder

        // Reducer of set callback loader
        .addCase(settingsSetCallbackLoaderAC, (state, action) => {
            state.callbackLoader = action.payload.callbackLoader
        })

        // Reducer of set callback data
        .addCase(settingsSetCallbackDataAC, (state, action) => {
            state.callbackData = action.payload.callbackData
        })

        // Reducer of clear state
        .addCase(logoutAC, ( state ) => {
            state = {...state, ...initialState}
        })


})